export default __webpack_public_path__ + "static/media/ID_Guidelines.287694ab.png";